var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from "@cloudscape-design/components/button";
/**
 * Wrapper component for container type toolbar item.
 * This will add close active content button on the
 * top right.
 */
export var ToolbarContainerItemContent = function (props) {
    var _a;
    return (_jsxs("div", __assign({ className: "container_item_wrapper" }, { children: [_jsx("div", __assign({ className: "close_content", title: (_a = props.closeButtonTitle) !== null && _a !== void 0 ? _a : props.closeButtonAriaLabel }, { children: _jsx(Button, { iconName: "close", variant: "icon", ariaLabel: props.closeButtonAriaLabel, onClick: props.close }) })), props.children] })));
};
